import { FormLabel, styled } from "@mui/material";
import { BaseLabelPropsType } from "../../../types/component.type";

export const BaseLabel = styled(FormLabel)<BaseLabelPropsType>(({ colour, fontsize, fontweight }) => {
    return {
        fontFamily: "Poppins",
        fontWeight: fontweight || 500,
        fontSize: fontsize || "16px",
        lineHeight: "normal",
        color: colour || "var(--dark-color)",
        marginBlock: "calc(var(--basic-margin)/4)",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
})